import { jsx as _jsx } from "react/jsx-runtime";
// Component.
// -----------------------------------------------------------------------------
// Its only function is to render the 'tbody' node.
export const BaseTableBody = ({ children }) => {
    return _jsx("tbody", { children: children });
};
//# sourceMappingURL=BaseTableBody.js.map